<script lang="ts">
	//Formatters
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';
	//Helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';
	import { getElevationUnitOptions } from 'src/helpers/units/elevation_units';
	import { getWindUnitOptions } from 'src/helpers/units/wind_units';
	import { getTemperatureUnitOptions } from 'src/helpers/units/temperature_units';
	import { getPrecipitationUnitOptions } from 'src/helpers/units/precipitation_unit';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Text, Token, Loader, Select, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let units: 'temperature_unit' | 'elevation_unit' | 'wind_unit' | 'precipitation_unit';

	const getOptions = (units) => {
		switch (units) {
			case 'temperature_unit':
				return getTemperatureUnitOptions();
			case 'elevation_unit':
				return getElevationUnitOptions();
			case 'wind_unit':
				return getWindUnitOptions();
			case 'precipitation_unit':
				return getPrecipitationUnitOptions();
		}
	};

	const save = async () => {
		const _device = get(devices)[device?.id];
		if (!_device || waitForResponse) return;
		const ht_ui = _device?.ht_ui || {};
		ht_ui[units as string] = value;
		waitForResponse = true;
		await requestEditDevice({
			..._device,
			ht_ui,
		});
		waitForResponse = false;
	};

	let waitForResponse = false;
	let options = getOptions(units);
	let value = device?.ht_ui?.[units] || options[0]?.value;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('label_choose_units', {
		default: 'Choose units:',
	})}
</Text>

{#if options.length === 2}
	<div
		class={classMap({
			'd-flex': true,
			'justify-content-center': waitForResponse,
		})}
	>
		{#if waitForResponse}
			<Loader size="m" class="align-self-center" />
		{:else}
			{#each options as option}
				<Token
					id="token-{option.value}"
					selected={value === option.value}
					size="m"
					title={option.title}
					class="mr-s"
					on:click={() => {
						value = option.value;
						save();
					}}
				/>
			{/each}
		{/if}
	</div>
{:else}
	<Select
		id="select-zjpx3he"
		aria-label={$format('label_elevation_units', { default: 'Elevation units' })}
		{options}
		value={options.find((i) => i.value === value) || options[0]}
		icon={null}
		size="m"
		class="mb-s"
		on:change={(e) => {
			value = e.detail['value'];
		}}
	/>
	<Button width="full" size="m" on:click={save} loading={waitForResponse}>
		{$format('button_save', { default: 'Save' })}
	</Button>
{/if}
